import { useGetPolicy } from 'features/policySingle/hooks/useGetPolicy';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPolicyChecklists } from 'selectors/policies';

import { PolicyChecklists } from './PolicyChecklists';

export const PolicyChecklistsContainer = () => {
  const { policyId } = useParams<{ policyId: string }>();
  const { policy, isLoading } = useGetPolicy(policyId);
  const { withStudentChecklist, withHealthCardChecklist } = useSelector(
    getPolicyChecklists(policy)
  );

  if (isLoading || !policy) return null;

  return (
    <PolicyChecklists
      withStudentChecklist={withStudentChecklist}
      withHealthCardChecklist={withHealthCardChecklist}
      policy={policy}
    />
  );
};

export default PolicyChecklistsContainer;
